module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "numo.8fff37bf.svg";